export default __webpack_public_path__ + "static/media/CDC_fr.c6e95e42.svg";